import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { dbLocalIndex, pages } from '../../constants/';
import { CartService } from '../../services/cart.service';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-successmodal',
  templateUrl: './successmodal.page.html',
  styleUrls: ['./successmodal.page.scss'],
})

export class SuccessmodalPage implements OnInit {
  @Input() idPedido: number;
  @Input() totalSinDescuento: number;
  @Input() descuento: number;
  @Input() idCliente: number;
  @Input() cliente: string;
  @Input() direccionSeleccionada: string;
  @Input() card: string;
  @Input() idFormaPago: number;
  @Input() fechaEstimada: Date;
  fechaActual = Date.now();
  estado: string;
  constructor(
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private cartService: CartService,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    if ( this.idFormaPago === 4 ) {
      this.estado = `Pagado con tarjeta XXXX-${ this.card }`;
    } else if ( this.idFormaPago === 1 ) {
      this.estado = 'Pendiente de pago';
    } else {
      this.estado = 'En espera';
    }
    this.eliminarDatos().finally();
  }

  async close() {
    await this.modalCtrl.dismiss();
    await this.navCtrl.navigateRoot(pages.home);
  }

  async goHome() {
    await this.close();
    await this.navCtrl.navigateRoot(pages.home);
  }

  async goStatus() {
    await this.close();
    await this.navCtrl.navigateRoot(pages.myorders);
  }

  async eliminarDatos() {
    // Eliminamos los items del carrito
    // const productos = await this.storageService.getCarrito();
    // this.cartService.removeAllElementCart( productos );
    this.cartService.resetCart();

    // Eliminamos el resto de datos relacionados al pedido
    await this.storageService.delete(dbLocalIndex.carrito);
    await this.storageService.delete(dbLocalIndex.lugarEntregaSeleccionado);
    await this.storageService.delete(dbLocalIndex.metodoPagoSeleccionado);
    await this.storageService.delete(dbLocalIndex.preferenciasPedido);
    await this.storageService.delete(dbLocalIndex.preferenciaPedidoOtros);
    await this.storageService.delete(dbLocalIndex.disponibilidadInmediata);
    await this.storageService.delete(dbLocalIndex.fechaEntrega);
    await this.storageService.delete(dbLocalIndex.haveCoupon);
    await this.storageService.delete(dbLocalIndex.couponInfo);
  }

}
